import { cn } from '@/utils/styles';

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('animate-pulse rounded-md bg-neutral-600/10', className)}
      {...props}
    />
  );
}

export { Skeleton };
